























import {Component, Vue} from 'vue-property-decorator'

@Component({
  name: 'testing-step-6'
})
export default class TestingStep6 extends Vue{
  mounted () {
    this.$emit('next-step-available')
  }
}
